import { gql } from "graphql-tag";

export const COMPANY_SETTINGS_FRAGMENT = gql`
  fragment CompanySettings on Company {
    settings {
      allowTeamMode
      requireKilometerData
      requireSupportActivity
      allowTransfers
      requireExpenditures
      requireMissionName
      allowOtherTask
      otherTaskLabel
    }
    weeklyThresholds {
      maxWorkInHours
      minRestInHours
      maxWorkedDays
    }
  }
`;

export const FRAGMENT_LOCATION_FULL = gql`
  fragment FullLocation on LocationEntry {
    id
    name
    alias
    postalCode
    city
    kilometerReading
  }
`;

export const FRAGMENT_ACTIVITY = gql`
  fragment Activity on Activity {
    id
    type
    startTime
    endTime
    lastUpdateTime
    lastSubmitterId
    dispute
    user {
      id
      firstName
      lastName
    }
    submitterId
  }
`;
export const FULL_MISSION_FRAGMENT = gql`
  ${COMPANY_SETTINGS_FRAGMENT}
  ${FRAGMENT_LOCATION_FULL}
  fragment FullMissionData on Mission {
    id
    name
    submitterId
    submitter {
      firstName
      lastName
    }
    isHoliday
    deletedAt
    deletedBy
    isHoliday
    validations {
      submitterId
      receptionTime
      isAdmin
      isAuto
      justification
      userId
    }
    vehicle {
      id
      name
      registrationNumber
    }
    context
    expenditures {
      id
      type
      missionId
      userId
      receptionTime
      spendingDate
    }
    company {
      id
      name
      siren
      legalName
      ...CompanySettings
    }
    activities(includeDismissedActivities: false) {
      id
      type
      missionId
      startTime
      endTime
      userId
      submitterId
      lastSubmitterId
      dispute
      receptionTime
      user {
        id
        firstName
        lastName
      }
      versions {
        id
        startTime
        endTime
        receptionTime
        submitter {
          id
          firstName
          lastName
        }
      }
    }
    comments {
      id
      text
      missionId
      receptionTime
      submitter {
        id
        firstName
        lastName
      }
    }
    startLocation {
      ...FullLocation
    }
    endLocation {
      ...FullLocation
    }
    pastRegistrationJustification
    endedUserIds
  }
`;

export const WORK_DAYS_DATA_FRAGMENT = gql`
  fragment WorkDayData on WorkDayConnection {
    edges {
      node {
        user {
          id
          firstName
          lastName
        }
        day
        missionNames
        startTime
        lastActivityStartTime
        endTime
        expenditures
        serviceDuration
        totalWorkDuration
        activityDurations
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
`;

export const REGULATION_COMPUTATIONS_FRAGMENT = gql`
  fragment RegulationComputations on RegulationComputationByDayOutput {
    day
    regulationComputations {
      day
      submitterType
      regulationChecks {
        type
        label
        description
        regulationRule
        unit
        alert {
          extra
        }
      }
    }
  }
`;

export const OBSERVED_INFRACTIONS_FRAGMENT = gql`
  fragment ObservedInfractions on ObservedInfraction {
    sanction
    date
    isReportable
    isReported
    label
    description
    articles
    type
    unit
    extra
    business {
      id
      transportType
      businessType
    }
  }
`;

export const FULL_TEAM_FRAGMENT = gql`
  fragment FullTeamData on Team {
    id
    name
    creationTime
    adminUsers {
      id
      firstName
      lastName
    }
    users {
      id
      firstName
      lastName
    }
    vehicles {
      id
      name
    }
    knownAddresses {
      id
      alias
      name
      postalCode
      city
    }
  }
`;

export const FULL_EMPLOYMENT_FRAGMENT = gql`
  fragment FullEmploymentData on Employment {
    id
    startDate
    endDate
    dismissedAt
    validationStatus
    isAcknowledged
    email
    hasAdminRights
    latestInviteEmailTime
    lastActiveAt
    teamId
    isActive
    isTerminated
    isInactive
    status
    detachmentRequest {
      requestedAt
      lastSentAt
    }
    business {
      transportType
      businessType
    }
    weeklyThresholds {
      maxWorkInHours
      minRestInHours
      maxWorkedDays
    }
    companyId
    company {
      id
      name
      siren
    }
    user {
      id
      email
      firstName
      lastName
    }
  }
`;

export const CONTROL_BULLETIN_FRAGMENT = gql`
  fragment ControlBulletin on ControlBulletinFields {
    userBirthDate
    userNationality
    siren
    companyAddress
    locationDepartment
    locationCommune
    locationLieu
    vehicleRegistrationCountry
    missionAddressBegin
    missionAddressEnd
    transportType
    articlesNature
    licenseNumber
    licenseCopyNumber
    observation
    isVehicleImmobilized
    businessType
    vehicleWeight
    realVehicleWeight
  }
`;

export const CONTROL_DATA_FRAGMENT = gql`
  fragment ControlData on ControllerControl {
    id
    controlType
    qrCodeGenerationTime
    controlTime
    nbControlledDays
    creationTime
    companyName
    userFirstName
    userLastName
    controlBulletinCreationTime
    controlBulletinUpdateTime
    vehicleRegistrationNumber
    isDayPageFilled
    note
    nbReportedInfractions
    deliveredByHand
    sentToAdmin
    sentToDriver
    controlBulletin {
      locationLieu
    }
  }
`;

export const CONTROLLER_USER_FRAGMENT = gql`
  fragment ControllerUser on ControllerUser {
    id
    firstName
    lastName
    email
    grecoId
    isMinistryOfInterior
    isCtt
  }
`;

export const USER_CONTROL_SUMMARY_FRAGMENT = gql`
  fragment UserControlSummary on ControllerControl {
    id
    creationTime
    nbReportedInfractions
    controlBulletinCreationTime
    controlBulletinUpdateTime
    controlBulletin {
      locationLieu
    }
    controllerUser {
      id
      grecoId
      firstName
      lastName
    }
  }
`;

export const USER_AGREEMENT = gql`
  fragment UserAgreementData on UserAgreement {
    hasAcceptedCgu
    hasRejectedCgu
    shouldAcceptCgu
    isBlacklisted
    answerDate
    expiresAt
    cguVersion
  }
`;

export const NOTIFICATION_FRAGMENT = gql`
  fragment NotificationData on Notification {
    id
    type
    creationTime
    read
    data
  }
`;
